import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { CLOSE_CHAT_SCREEN } from '../../redux/reducers/chatScreenReducer';
import ChatScreen from '../chatScreen/ChatScreen';
import ToogleChatButton from '../toggleChatButton/ToggleChatButton';

const ChatBotWithToggleButton = () => {
  // useSocket();
  const dispatch = useDispatch<AppDispatch>();

  const isChatOpen = useSelector(
    (state: RootState) => state.chatScreen.isChatOpen,
  );

  const onClose = () => {
    dispatch({
      type: CLOSE_CHAT_SCREEN,
    });
  };

  return (
    <div className="font-sans text-sm">
      {isChatOpen && <ChatScreen onClose={onClose} />}
      <ToogleChatButton />
    </div>
  );
};

export default ChatBotWithToggleButton;
